import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register the scales, elements, and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const HomeStatisticsCard = ({ dashboardListings }) => {
  const chartRef = useRef(null);

  const createGradient = (ctx, area) => {
    const gradient = ctx.createLinearGradient(0, area.top, 0, area.bottom);
    gradient.addColorStop(0, "rgba(235, 102, 43, 0.5)"); // Orange color at the top
    gradient.addColorStop(1, "rgba(255, 255, 255, 0.05)"); // White color at the bottom with 5% opacity
    return gradient;
  };

  // Sample data for Chart.js
  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    datasets: [
      {
        label: "Orders",
        data: [50, 60, 70, 180, 190, 120, 200],
        borderColor: "rgba(235, 102, 43, 1)",
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;

          if (!chartArea) {
            return null;
          }

          return createGradient(canvasCtx, chartArea); // Use custom gradient
        },
        borderWidth: 2,
        fill: "start",
        tension: 0.4, // Adds smooth curves
      },
      {
        label: "New Line",
        data: [100, 150, 130, 160, 170, 140, 180],
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;

          if (!chartArea) {
            return null;
          }

          const gradient = canvasCtx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(54, 162, 235, 0.4)");
          gradient.addColorStop(1, "rgba(54, 162, 235, 0)");
          return gradient;
        },
        borderWidth: 2,
        fill: "start",
        tension: 0.4,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: false, // Hide the x-axis completely
      },
      y: {
        display: false, // Hide the y-axis completely
        beginAtZero: true,
      },
    },
    elements: {
      point: {
        radius: 0, // Hide points on the line
      },
    },
  };

  return (
    <Card className="dod-dash-main-page-total-orders-chart">
      <div className="d-flex flex-column align-items-start justify-content-between">
        <div className="dod-dash-main-page-total-orders-header mt-2 ms-3">
          <h1 className="dod-dash-main-page-total-orders-header-total-title-main m-0 pb-2">
            Total orders: <span>{dashboardListings?.products?.totalOrders}</span>
          </h1>

          <div className="d-flex align-items-center gap-2">
            <div className="dod-dash-main-page-total-orders-header-icon-orange"></div>
            <h5 className="dod-dash-main-page-total-orders-header-title m-0">
              Today booking {dashboardListings?.products?.todayOrder}
            </h5>
          </div>
          <div className="d-flex align-items-center gap-2 mt-2 mb-0">
            <div className="dod-dash-main-page-total-orders-header-icon-black"></div>
            <h5 className="dod-dash-main-page-total-orders-header-title m-0">
              This week booking {dashboardListings?.products?.CurrentWeekOrder}
            </h5>
          </div>
        </div>
        <Line
          ref={chartRef}
          data={data}
          options={options}
          className="dod-dash-main-page-order-chart"
        />
      </div>
    </Card>
  );
};

export default HomeStatisticsCard;
